module.exports = __webpack_public_path__ + "img/verres2.7b5b3671.jpeg";